// ---app---
export const SET_ISREADY = 'APP/SET_ISREADY'

// ---auth---
export const SIGN_UP = 'AUTH/SIGN_UP'
export const SIGN_IN = 'AUTH/SIGN_IN'
export const LOG_OUT = 'AUTH/LOG_OUT'
export const VERIFY_TOKEN = 'AUTH/VERIFY_TOKEN'

// ---alert---
export const SET_ALERT = 'APP/SET_ALERT'

// ---loader---
export const SHOW_LOADER = 'APP/SHOW_LOADER'
export const HIDE_LOADER = 'APP/HIDE_LOADER'

// ---links---
export const GENERATE_LINK = 'LINKS/GENERATE_LINK'
export const GET_LINK_BY_ID = 'LINKS/GET_LINK_BY_ID'
export const GET_LINKS = 'LINKS/GET_LINKS'
export const DELETE_LINK = 'LINKS/DELETE_LINK'
